import commandeAFacturerTransformer
  from '@/services/commande/commandeAFacturer/commandeAFacturerTransformer';
import HTTP from '../HTTP';

const URL_BASE = 'gescom/CommandeAFacturer/';

export default async function getAllCommandeAFacturer(params, limit) {
  const inputServer = commandeAFacturerTransformer(params);
  if (limit !== undefined) inputServer.MaxResultCount = limit;
  const response = await HTTP.post(URL_BASE + 'PGetAllAsync', inputServer);
  return response;
}

export async function commenter(payload) {
  const response = await HTTP.post(URL_BASE + 'CommenterAsync', payload);
  return response;
}
